import sanitizeHtml from "sanitize-html";

/** Rich HTML subset aligned with legacy DOMPurify `USE_PROFILES: { html: true }` + forbidden script/iframe/object/embed. */
const CMS_ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "div",
  "span",
  "br",
  "hr",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "sub",
  "sup",
  "ul",
  "ol",
  "li",
  "a",
  "img",
  "blockquote",
  "pre",
  "code",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "figure",
  "figcaption",
] as const;

/** Sanitize CMS HTML for public rendering (XSS-safe subset). Pure JS — no jsdom (avoids ESM/CJS issues on Node). */
export function sanitizeCmsHtml(html: string): string {
  return sanitizeHtml(html ?? "", {
    allowedTags: [...CMS_ALLOWED_TAGS],
    allowedAttributes: {
      a: ["href", "name", "target", "rel", "title"],
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
      td: ["colspan", "rowspan"],
      th: ["colspan", "rowspan"],
      "*": ["class", "id"],
    },
    allowedSchemes: ["http", "https", "mailto", "tel"],
    allowProtocolRelative: false,
  });
}
